import React from 'react';
import { BackLayout } from '../../../components/layouts/back/BackLayout';
import { AwardDetailForm } from '../../../components/back/form/AwardDetailForm';

export const AwardCreate = () => {
    return (
        <BackLayout>
            <AwardDetailForm />
        </BackLayout>
    );
};
